<script lang="ts">
    import {meta} from 'tinro';
    const route = meta();

    import { sendGAEvent } from '../lib/utilities/ga.js';

    import {databases,filteredDatabases} from "../lib/data/databases.js";
    import DatabaseList from "../lib/components/DatabaseList.svelte";
    import FilterBar from "../lib/components/FilterBar.svelte";
    import TextBlock from "../lib/components/TextBlock.svelte";
    import NoResults from "../lib/components/NoResults.svelte";

    export let content ='';

    let searchTerm = "Get Started";

    databases.subscribe(dbs => {
        const filtered = dbs.filter(database => {
            if (database.classes) {
                for (let cls of database.classes) {
                    if (cls.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return true;
                    }
                }
            }
            return false;
        });
        filteredDatabases.set(filtered);
    });
</script>

    <FilterBar parent_id="start-here">
            <TextBlock
                    title={content.label}
                    text={content.heading}
            />
    </FilterBar>
    <DatabaseList
            on:openDialog
            bind:databases={$filteredDatabases}
    />
    <NoResults />

